import * as React from "react";
import { useMemo } from "react";
import { SECURITY_EVENT_STATUSES } from "security-app/hooks/api/securityEventsAPI.types";
import { Select } from "components/common";
import eventStatusLabel from "security-app/logic/eventStatusLabel";
import { useTranslation } from "react-i18next";
const StatusFilter = ({ value, onSelect, selectedValues }) => {
  const { t } = useTranslation("enterprise_search");
  const statusesOptions = useMemo(
    () => Object.keys(SECURITY_EVENT_STATUSES).map((status) => ({
      label: eventStatusLabel(status),
      value: status,
      disabled: selectedValues.includes(status)
    })),
    [selectedValues]
  );
  return /* @__PURE__ */ React.createElement(
    Select,
    {
      placeholder: t("status_filter.placeholder"),
      clearable: false,
      menuIsOpen: true,
      options: statusesOptions,
      onChange: onSelect,
      value
    }
  );
};
export default StatusFilter;
